import { render, staticRenderFns } from "./spu-select.vue?vue&type=template&id=138dc55f"
import script from "./spu-select.vue?vue&type=script&lang=js"
export * from "./spu-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports